import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { AlertComponent } from '../../../../../components/alert/alert.component';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { Alert, ALERT_TYPE } from '../../../../../components/alert/alert.model';
import { ReportsService } from '../../_core/reports.service';
import { CreditSummaryRequest } from '../../_core/models/credit-summary.model';
import { TableProComponent } from '../../../../../components/table-pro/table-pro.component';
import { TableProConfig } from '../../../../../components/table-pro/core/table-pro.model';

@Component({
  selector: 'credit-summary',
  standalone: true,
  imports: [CommonModule, I18nModule, LocalLoaderComponent, AlertComponent, TableProComponent],
  templateUrl: './credit-summary.component.html',
  styleUrl: './credit-summary.component.scss',
})
export class CreditSummaryComponent implements OnInit, OnDestroy {
  report$ = new BehaviorSubject<CreditSummaryRequest>(initialStatus);

  tableConfig: TableProConfig = {
    classContainer: 'm-t-20',
    collumnConfig: [
      { id: 'invoice', index: 0, type: 'number' },
      { id: 'invoiceDate', index: 1, type: 'date' },
      { id: 'originalAmount', index: 2, type: 'number' },
      { id: 'amountDue', index: 3, type: 'number' },
      { id: 'dueDate', index: 4, type: 'date' },
      { id: 'PO', index: 5, type: 'text' },
      { id: 'status', index: 6, type: 'text' },
      { id: 'creditAdjustment', index: 7, type: 'text' },
      { id: 'order', index: 8, type: 'number' },
    ],
  };

  subscription = new Subscription();

  alertDanger: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: 'm-t-20',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(private reportsService: ReportsService) {}

  ngOnInit(): void {
    this.getCreditSummaryReport();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getCreditSummaryReport() {
    this.report$.next(loadingStatus);

    this.subscription.add(
      this.reportsService
        .getCreditSummary()
        .pipe(take(1))
        .subscribe(_report => {
          const report: CreditSummaryRequest = {
            ..._report,
          };

          if (report.hasError) {
            this.alertDanger.content = report.message!;
          }

          this.report$.next(report);
        }),
    );
  }
}
